var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('treeselect',{attrs:{"multiple":true,"options":_vm.options},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('div',{on:{"click":_vm.sub}},[_vm._v("submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }